import React from 'react';
import { Link, Navigate, useLocation, useParams } from 'react-router-dom';
import { MapPinIcon } from 'lucide-react';
import { territoryById } from '../utils/territory';
import { EntityDashboard } from '../components/territory/EntityDashboard';
import { EmptyState } from '../components/ui/EmptyState';
export function TerritoryDetail() {
  const {
    territoryId,
    aopId
  } = useParams();
  const {
    search
  } = useLocation();
  if (!territoryId) return <Navigate to={`/${search}`} replace data-id="element-764" data-mp="1622dyb4d3h49" />;
  const territory = territoryById.get(territoryId);
  const aop = territory && aopId ? territory.aops.find(a => a.id === aopId) : undefined;
  if (!territory || aopId && !aop) {
    return <div className="rounded-lg border border-line bg-white" data-id="element-765" data-mp="1jzqx9eis6g77">
        <EmptyState icon={<MapPinIcon className="h-5 w-5" data-id="element-767" data-mp="2qgbejp8bjzmf" />} title={territory ? 'AOP not found in this territory' : 'Territory not found'} description="The link may be out of date." action={<Link to={`/${search}`} className="text-xs font-semibold text-navy hover:underline" data-id="element-768" data-mp="nz3156fksmk0">Back to dashboard</Link>} data-id="element-766" data-mp="1jxwf27yw926t" />
      </div>;
  }
  return <EntityDashboard key={`${territory.id}-${aop?.id ?? 'all'}`} territory={territory} aop={aop} data-id="element-769" data-mp="j0jh5bkjlkua" />;
}